import type { MyPermissions } from '@tradeoutlet/shared';
import type { HelpMeta } from './types';

type Mine = Pick<MyPermissions, 'workspace' | 'scoped'> | null | undefined;

const holds = (mine: Mine, p: string) => Boolean(mine && (mine.workspace.includes(p) || mine.scoped.some(s => s.permissions.includes(p))));

/** An article is for the reader when it needs no permission, or they hold any one of its permissions anywhere. */
export function canRead(mine: Mine, a: Pick<HelpMeta, 'permissions'>): boolean {
  return !a.permissions.length || a.permissions.some(p => holds(mine, p));
}

/** Who may switch on "Show all guides" (including ones for roles they don't have). */
export const HELP_ADMIN_PERM = 'admin.help.manage';
export const canShowAll = (mine: Mine) => holds(mine, HELP_ADMIN_PERM);

export function visibleArticles<T extends Pick<HelpMeta, 'permissions'>>(all: T[], mine: Mine, showAll: boolean): T[] {
  return showAll && canShowAll(mine) ? all : all.filter(a => canRead(mine, a));
}
